import React from 'react';
import PropTypes from 'prop-types';

// import components
import ComparePopupContentProducts from '@/kenwood/components/molecules/ComparePopupContentProducts';
import ComparePopupContentResults from '@/kenwood/components/molecules/ComparePopupContentResults';

const ComparePopupContent = ({
  productsCode,
  products,
  results,
  showDifferences,
  viewLabel,
  buyLabel,
  seeDifferencesLabel,
  resultsGeneralSpecsLabel,
  resultsIdLabel,
  onPopProduct,
  onToggleShowDifferences,
}) => (
  <section className='ken-compare__popup__content'>
    <section className='ken-compare__popup__inner-content ken-wrapper--big-grid'>
      <ComparePopupContentProducts
        products={products}
        showDifferences={showDifferences}
        viewLabel={viewLabel}
        buyLabel={buyLabel}
        seeDifferencesLabel={seeDifferencesLabel}
        onPopProduct={onPopProduct}
        onToggleShowDifferences={onToggleShowDifferences}
      />
      <ComparePopupContentResults
        productsCode={productsCode}
        results={results}
        showDifferences={showDifferences}
        resultsGeneralSpecsLabel={resultsGeneralSpecsLabel}
        resultsIdLabel={resultsIdLabel}
      />
    </section>
  </section>
);

ComparePopupContent.propTypes = {
  productsCode: PropTypes.arrayOf(PropTypes.string),
  products: PropTypes.arrayOf(PropTypes.shape()),
  results: PropTypes.shape(),
  showDifferences: PropTypes.bool,
  viewLabel: PropTypes.string.isRequired,
  buyLabel: PropTypes.string.isRequired,
  seeDifferencesLabel: PropTypes.string.isRequired,
  resultsGeneralSpecsLabel: PropTypes.string.isRequired,
  resultsIdLabel: PropTypes.string.isRequired,
  onPopProduct: PropTypes.func,
  onToggleShowDifferences: PropTypes.func,
};

ComparePopupContent.defaultProps = {
  productsCode: [],
  products: [],
  results: {},
  showDifferences: false,
  onPopProduct: null,
  onToggleShowDifferences: null,
};

export default ComparePopupContent;
